import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import CustomImg from '../image/CustomImg';
import {isMobileOnly} from 'react-device-detect';

// const mHeight = "96vw"; // prev
// const mHeight = "98px";
// const pHeight = "650px";
// const mPageMargin = "0 4vw";
const mPageMargin = "margin: 0";

const SlideBannerBlock = styled.div`

  position:relative;
  display: block;

  height: ${props=>props.layouts.height};
  margin: ${props=>props.layouts.margin};
  text-align: center;
  .main-slide-inner {
    width: ${props=>props.layouts.width};
    
    }
        
  
  .slick-slider {
      opacity: 0;
      visibility: hidden;
      animation: fadeOut ease-out 1s;
      //-webkit-transition: opacity 5s ease-in;
      &.slick-initialized {
      animation: fadeIn ease-in 1s;
      visibility: visible;
      opacity: 1;    
      }
      z-index:1;  
  }
  
 
  .slick-slider .slick-list {}
  .link {display:unset !important  } // to avoid gap between image and wrapper div  
  .slide-img {
    display: block;
    vertical-align: middle;
    cursor: pointer;
    width:${props=>props.layouts.width};
    height:${props=>props.layouts.height};
    //margin: ${props=>props.layouts.margin};
    border-radius: 0;
    // ${isMobileOnly?`
    //     // border-radius: 0;
    // `:`
    //     // object-fit:cover;
    //     // border-bottom-left-radius:40px;    
    // `};
    //animation: fadeIn ease-in-out 0.5s;
    
    &.dummy { display:block; 
              position:absolute; 
              z-index: 0;
              top:0;
              width:100%;
              img {
              position:relative;
              margin-right: auto;
              object-fit: cover;
              height: ${props=>props.layouts.height};
              width:  ${props=>props.layouts.width};
              
              }
              }
    
        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
    
  }
  //background: #fef7c8;
    .slick-arrow {
      position: absolute;
      top: 50%;
      width: 40px;
      height: 72px;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
      text-indent: -9999px;
      overflow: hidden;
      z-index: 1;
      
      &.slick-next { right: 52px; background: url('/assets/images/icon/slide_next-icon.png') center center/auto no-repeat;}
      &.slick-prev { left: 52px; background: url('/assets/images/icon/slide_prev-icon.png') center center/auto no-repeat;}          
    }
  
  .slick-dots-box {
      position: absolute;
      bottom: 20px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
    .slick-dots {
      li {
          position: relative;
          float: left;
          width: ${(props)=>{             
            const unit = "px";
            const base = isMobileOnly?120:160;             
            return ((base)/props.slideItemsInfo.length)+unit;            
          }}; //117px;
          height: 2px;
          background-color: #f2f1f1;
          cursor: pointer;          
         button {
             position: absolute;
             top: 0;
             left: 0;
             width: 0;
             height: 100%;
             background-color: #f2f1f1;
             text-indent: -9999px;
             overflow: hidden;      
         }
      }    
    }
    .slick-progress_bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 2px;
      background-color: rgba(51,51,51,0.5);
      color: rgba(255,255,255,0.7);
      
      transition: width 1s ease-in-out;
    }    
     .control-btn {
        position: absolute;
        bottom: -6px;
        right: -32px;
        width: 14px;
        height: 14px;
        background: url("/assets/images/icon/stop-icon.png") center center/auto no-repeat;
      }
     .control-btn.play {
        background: url("/assets/images/icon/play-icon.png") center center/auto no-repeat;
      }        
  }
`;


// const SlideBanner = (slideItemsInfo, mWidth, mHeight, pWidth, pHeight) => {
const SlideBanner = (props) => {
  const dispatch = useDispatch();
  const [slideIndex, setSlideIndex] = useState(0);
  const [isPlay, setIsPlay] = useState(props.autoPlay);
  const slider = useRef();
  const actionButton = useRef();
  const progressBar = useRef();
  const [progressWidth, setWidth] = useState('0');
  const [loaded, setLoadState] = useState(false);

  const layouts = () =>{
    return ({
      width: isMobileOnly?(props.mWidth?props.mWidth:"92vw"):(props.pWidth?props.pWidth:"650px"),
      height: isMobileOnly?(props.mHeight?props.mHeight:"92vw"):(props.pHeight?props.pHeight:"650px"),
      margin: isMobileOnly?(props.mMargin?props.mMargin:"0 4vw"):(props.pMargin?props.pMargin:"0 auto"),
      dummy: isMobileOnly?(props.mDummy?props.mDummy:"/assets/images/common/main_banner-mobile-dummy.png"): (props.pDummy?props.pDummy:"/assets/images/common/main_banner-web-dummy.png")
    })
  }

  const playPause = ()=>{
    if(isPlay){
      slider.current.slickPause();
      actionButton.current.classList.add('play');
    } else {
      slider.current.slickPlay();
      actionButton.current.classList.remove('play');
    }
    setIsPlay(!isPlay)
  }

  //setting initial width for progress bar
  // setWidth((100/mainCmItems.length)+"%");

  const updateProgressBarWidth = (current,next)=>{
    // if(!slider.current)return;
    const slideCount = props.slideItemsInfo.length;
    const slideVal = 100 / slideCount;

    const barWidth = slideVal * (next + 1);
    setWidth(barWidth+'%');
    setSlideIndex(next)
  }

  const nextSlide = ()=>{
    slider.current.slickNext();
  }
  const prevSlide = () =>{
    slider.current.slickPrev();
  }
  progressWidth==="0"&&props.slideItemsInfo.length&&updateProgressBarWidth(-1,0)

  const IMG = (item1)=>{
    let img = null;
    if(item1.item.img){
        img = <img className="slide-img" alt={item1.title?item1.title:"이미지"} src={item1.item.img}/>
    } else if(item1.item.bnnr_title){
      img = <img className="slide-img" alt={item1.item.bnnr_title} src={isMobileOnly?item1.item.bnnr_img_mo_url:item1.item.bnnr_img_url}/>
    }
    return img;
  }
  const settings = {
    arrows: false,
    lazyLoad:true,
    dots: true,
    infinite: true,
    autoplay: isPlay,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    className: 'main-slide-inner',
    adaptiveHeight: true,
    // onLazyLoad: ()=>{setLoadState(true)},
    // onreadystatechange:()=>{console.log('loaded!!')},
    appendDots: dots=>(
      <div className="">
        <div className="slick-dots-box">
          <ul className="slick-dots" style={{ display: "block" }}>{dots}</ul>
          {!!props.showControl&&<button ref={p=>actionButton.current = p} type="button" className="control-btn" onClick={playPause}/>}
          <div ref={p=>progressBar.current = p} className="slick-progress_bar" style={{width:progressWidth}}/>
        </div>
        {!!props.showControl&&<div className="slick-arrow slick-prev" onClick={prevSlide}/>}
        {!!props.showControl&&<div className="slick-arrow slick-next" onClick={nextSlide}/>}


      </div>
    ),
    beforeChange:(current,next)=>updateProgressBarWidth(current,next)

  };

  const handleClick = (url)=>{
    window.location.href = url;
  }

  return (
    <SlideBannerBlock cnt={props.slideItemsInfo.length} slideItemsInfo={props.slideItemsInfo} layouts={layouts()}>
      <Slider ref={s=>slider.current = s} {...settings} >
        {props.slideItemsInfo&&props.slideItemsInfo.length&&props.slideItemsInfo.map((item,key) => {
          return(
            <a className="link" key={key} href={!!item.landing_url?item.landing_url: undefined} style={{verticalAlign:"middle", display:"block"}}>
              <IMG key={key} item={item}/>
            </a>
          )
        })}
      </Slider>
    </SlideBannerBlock>
  );
};

export default SlideBanner;
